import * as constants from "./constants";

export const fetchDashboardRegisters = (filters) => ({
  type: constants.FETCH_DASHBOARD_REGISTERS,
  data: filters,
});

export const fetchDashboardRegistersSuccess = (data) => ({
  type: constants.FETCH_DASHBOARD_REGISTERS_SUCCESS,
  data,
});

export const fetchDashboardRegistersError = (error) => ({
  type: constants.FETCH_DASHBOARD_REGISTERS_ERROR,
  error,
});
